module.exports = __webpack_public_path__ + "img/04d.88c5e740.png";